import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { A11yModule } from '@angular/cdk/a11y';
import { StartTestDialogComponent } from './start-test-dialog.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		A11yModule
	],
	declarations: [
		StartTestDialogComponent
	],
	exports: [
		StartTestDialogComponent
	],
	providers: [
		TranslatePipe
	]
})
export class StartTestDialogModule {}
